import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { get, post, put } from "@utils/axios_api";

export function useBoardFormModal({ isOpen, isEdit, boardNum, onClose, onSuccess }) {
  const methods = useForm({
    defaultValues: {
      writer: "",
      title: "",
      content: "",
      testDate: "",
      atchFileId: "",
    },
    shouldFocusError: false, // Focus 방지
  });

  const { handleSubmit, setValue, watch, reset } = methods;

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [deletedFileSns, setDeletedFileSns] = useState([]);
  const [existingFilesCount, setExistingFilesCount] = useState(0);

  const [loadingDetail, setLoadingDetail] = useState(false);
  const [detailError, setDetailError] = useState(null);



  const onSubmit = async (formData) => {
    try {
      const formPayload = new FormData();
      formPayload.append("writer", formData.writer);
      formPayload.append("title", formData.title);
      formPayload.append("content", formData.content);
      formPayload.append("testDate", formData.testDate);
      formPayload.append("atchFileId", formData.atchFileId || "");

      selectedFiles.forEach((file) => {
        formPayload.append('files', file);
      });

      deletedFileSns.forEach((sn) => {
        formPayload.append("deletedFileSns", sn);
      });

      const url = isEdit ? `/board/${boardNum}` : "/board";
      const apiMethod = isEdit ? put : post;
      const response = await apiMethod(url, formPayload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (onSuccess) onSuccess(response);
      onClose();
    } catch (err) {
      console.error("저장 실패:", err);
      alert("저장에 실패하였습니다. 다시 시도해주세요.");
    }
  };

  const handleFormSubmit = handleSubmit(onSubmit);

  useEffect(() => {
    if (isOpen) {
      if (isEdit && boardNum) {
        setLoadingDetail(true);
        get(`/board/${boardNum}`)
          .then((data) => {
            const result = data.result;
            reset({
              writer: result.writer || "",
              title: result.title || "",
              content: result.content || "",
              testDate: result.testDate || "",
              atchFileId: result.atchFileId || "",
            });

            setExistingFilesCount(result.fileCount);

          })
          .catch((err) => {
            console.error("상세 데이터 조회 실패:", err);
            setDetailError(err);
          })
          .finally(() => {
            setLoadingDetail(false);
          });
      } else {
        reset({
          writer: "",
          title: "",
          content: "",
          testDate: "",
          atchFileId: "",
        });
        setExistingFilesCount(0); 
      }
      setSelectedFiles([]);
      setDeletedFileSns([]);
    }
  }, [isOpen, isEdit, boardNum, reset]);

  const markDelete = (file) => {
    // file.fileSn을 deletedFileSns에 추가 (중복 체크)
    if (!deletedFileSns.includes(file.fileSn)) {
      setDeletedFileSns((prev) => [...prev, file.fileSn]);
    }
  };


  return {
    ...methods,          
    handleFormSubmit,    // 폼 전송
    setValue,            // 담당자 세팅을 위한 value
    watch,
    loadingDetail,
    detailError,
    markDelete,          // 파일 순번 삭제 대기
    selectedFiles,       // 새로 업로드할 파일들
    setSelectedFiles,    // 파일 업로드 선택한 파일
    deletedFileSns,      // 기존 파일 중 삭제 예정
    existingFilesCount,  // 서버에서 받아온 "원래 있던 파일" 개수
    setExistingFilesCount, // 존재하는 파일 개수

  };
}
